export default "//static.tradera.net/touchweb/static/output/images/phone.7f9467cd.png";